import * as K from 'common/constants';
import { SortOrder } from 'common/graphqlTypes';

import { DATASOURCE } from 'schemas/types';

export enum VIEW_NAME {
  STANDARD = 'standard',
  EDR = 'edr',
  XDR = 'xdr',
}

// None or all of these can be overridden by a view, so they are optional
type DisplaySettings = {
  columns?: string[]; // Field names
  disableLiveTail?: boolean;
  displayMode?: K.DISPLAY_MODE;
  fontFamily?: K.FONT_FAMILY;
  searchAllTeamsByDefault?: boolean; // Cross-team search
  showChart?: boolean;
  sortOrder?: SortOrder;
};

export type ResultsTab = {
  id: string;
  label: string;
  icon?: string; // Only those bundled in DataSet, so this could be an enum
  filter?: string; // Filter that further constrains results in this tab
  displaySettings?: Partial<DisplaySettings>; // displaySettings for the tab, overrides the view
};

// TODO: We probably need a way to control which views a customer has access to
export type View = {
  name: string;
  label: string;
  order: number;
  dataSources?: DATASOURCE[];
  plugin?: string; // TODO: Convert to enum of known plugins?
  displaySettings: DisplaySettings;
  filter?: string;
  resultTabs?: ResultsTab[];
  // If this is set, we will hide the current Source and Logfile filter boxes
  sources?: {
    categoryField: string;
    categoryValue: string;
    sourceField: string;
    sourceLabel?: string;
    sourceLabelPlural?: string;
    sourceValues: string[];
  };
  classNames?: {
    table?: string;
    tableHeader?: string;
    tableField?: string;
    tableSystemField?: string;
    tableSeverityField?: string;
  };
};
